import React, { useRef, useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { saveResetPassword } from '../../../api/apiServices';
import toast, { Toaster } from 'react-hot-toast'

const ResetPortalPassword = (data) => {
    const params = useParams();
    const id = params.id

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const userRef = useRef();
    const errRef = useRef();

    // const [pf_number, setPfNumber] = useState(data?.pfNumber);

    const [password, setPassword] = useState('');
    const [validPassword, setValidPassword] = useState(false);
    const [passwordFocus, setPasswordFocus] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState('');
    const [validMatch, setValidMatch] = useState(false);
    const [matchFocus, setMatchFocus] = useState(false);

    const [errMsg, setErrMsg] = useState('');

    // const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
    const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,24}$/;

    useEffect(() => {
        userRef.current.focus();
    }, [])

    useEffect(() => {
        setValidPassword(PWD_REGEX.test(password));
        setValidMatch(password === confirmPassword);
    }, [password, confirmPassword])

    useEffect(() => {
        setErrMsg('');
    }, [password, confirmPassword])

    const handleCancel = () => {
        navigate(from, { replace: true });
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        const v2 = PWD_REGEX.test(password);
        if (!v2) {
            setErrMsg("Invalid Entry");
            return;
        }

        const data = {
            id: id,
            password: password
        }

        if (password === confirmPassword) {
            // try {
            saveResetPassword(data).then((response) => {
                if (response) {
                    confirmAlert({
                        customUI: ({ onClose }) => {
                            return (
                                <div className='confirm-container'>
                                    <h3>Reset Password </h3>
                                    <p>You have successfully reset your password</p>
                                    <p>Log in with your PF Number/Email and New Password</p>
                                    <br />
                                    <div className='confirm-setup-buttons'>
                                        <button
                                            style={{ width: "100px" }}
                                            className="btn btn-success"
                                            onClick={(e) => { handleCancel(e); onClose(); }}
                                        >
                                            Ok
                                        </button><br />
                                    </div>
                                </div>
                            );
                        }
                    })
                } else {
                    console.log("failure")
                }
            })
        } else {
            setErrMsg('Passwords do not match. Try again !')
        }
    }

    const pswdForm = (
        <>
            <form onSubmit={handleSubmit}>
                <div className="secret-code">
                    <h2>RESET PASSWORD</h2>
                    <p>Follow the password requirements to reset your password</p>
                </div>
                <div className="form-group row">
                    <label htmlFor="password" className="col-sm-4 col-form-label"></label>
                    <div className="col-sm-6">
                        <input
                            ref={userRef}
                            type="password"
                            id="password"
                            placeholder='New Password'
                            autoComplete="off"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            required
                            aria-invalid={validPassword ? "false" : "true"}
                            aria-describedby="pwdnote"
                            onFocus={() => setPasswordFocus(true)}
                            onBlur={() => setPasswordFocus(false)}
                            className='form-control'
                        />
                        <label htmlFor='password' >
                            <div className={validPassword ? "change-valid" : "change-hide"}>Password <i className="fas fa-check"></i></div>
                            <div className={validPassword || !password ? "change-hide" : "change-invalid"}>Password <i className="fas fa-times"></i></div>
                        </label>
                        <p id="pwdnote" className={passwordFocus && !validPassword ? "instructions" : "offscreen"}>
                            <i className="fas fa-info-circle"></i> 8 to 24 character password is required.<br />
                            Your password must include uppercase and lowercase letters, and a number. You may include any special character of your choice.<br />
                        </p>
                    </div>
                </div>

                <div className="form-group row">
                    <label htmlFor="confirm_password" className="col-sm-4 col-form-label"></label>
                    <div className="col-sm-6">
                        <input
                            type="password"
                            id="confirm_password"
                            placeholder='Confirm Password'
                            autoComplete="off"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            value={confirmPassword}
                            required
                            aria-invalid={validMatch ? "false" : "true"}
                            aria-describedby="confirmnote"
                            onFocus={() => setMatchFocus(true)}
                            onBlur={() => setMatchFocus(false)}
                            className='form-control'
                        />
                        <label htmlFor="confirm_password">
                            <div className={validMatch && confirmPassword ? "change-valid" : "change-hide"}> Confirm Password <i className="fas fa-check"></i></div>
                            <div className={validMatch || !confirmPassword ? "change-hide" : "change-invalid"}> Confirm Password <i className="fas fa-times"></i></div>
                        </label>
                        <p id="confirmnote" className={matchFocus && !validMatch ? "change-instructions" : "change-offscreen"}>
                            <i className="fas fa-info-circle"></i> Confirm Password must match the New Password.
                        </p>
                    </div>
                </div>
                <div className="panel-footer">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <button type="submit" className="btn btn-success" >Submit</button>
                        &nbsp;&nbsp;
                        <button
                            className='btn btn-danger'
                            onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>

                </div>
            </form>
        </>
    )

    return (
        <>
            <section className="content-header">
                <h1>Password Management</h1>
            </section>
            <Toaster toastOptions={{ position: "top-center" }} />
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            Reset Password
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                <div className="contact-container">
                                    <div className="form-group row">
                                        <label className='col-sm-2'></label>
                                        <div className="col-sm-4">
                                            <p ref={errRef} className={errMsg ? "change-errmsg" : "change-offscreen"} aria-live="assertive">{errMsg}</p>
                                            <br />
                                        </div>
                                    </div>
                                    {pswdForm}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ResetPortalPassword;
